export const getTokenizedHeaders = (token) => {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    "X-EnrollSourceMetaData": "Web",
  };
};

export const getHeaders = () => {
  return {
    "Content-Type": "application/json",
  };
};
